var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            border: "",
            "header-cell-style": {
              backgroundColor: "#FDEFE7",
              color: "#000000",
            },
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "left",
              align: "center",
              prop: "userName",
              label: "收货人(接收订单通知信息的人)",
              width: "190",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "userPhone",
              label: "手机号码",
              width: "180",
            },
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "邮政编码", width: "180" },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "address",
              label: "收货地址",
              width: "180",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }